import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { ShieldCheck, Droplets } from "lucide-react";
import { useLead } from "@/context/LeadContext";

export default function ExitIntentPopup() {
  const [open, setOpen] = useState(false);
  const { openLead } = useLead();

  useEffect(() => {
    if (sessionStorage.getItem("jr_exit_shown")) return;
    const handler = (e) => {
      if (e.clientY <= 0) {
        setOpen(true);
        sessionStorage.setItem("jr_exit_shown", "1");
        document.removeEventListener("mouseout", handler);
      }
    };
    const t = setTimeout(() => document.addEventListener("mouseout", handler), 8000);
    return () => { clearTimeout(t); document.removeEventListener("mouseout", handler); };
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-md bg-navy-deep border-sky/20 text-white text-center overflow-hidden" data-testid="exit-popup">
        <div className="absolute -top-16 -right-16 h-40 w-40 rounded-full bg-royal/20 blur-3xl" />
        <Droplets className="h-12 w-12 text-sky mx-auto shield-glow" />
        <DialogTitle asChild>
          <h3 className="font-display text-3xl font-extrabold mt-3">Wait — Don't Let Water Win</h3>
        </DialogTitle>
        <p className="text-slate-300 mt-2">Book a <span className="text-sky font-semibold">FREE inspection</span> before you leave. Our engineers will diagnose the exact problem at no cost.</p>
        <div className="flex items-center justify-center gap-2 text-xs text-slate-400 mt-3">
          <ShieldCheck className="h-4 w-4 text-gold" /> Up to 15-Year Warranty • 470+ Projects
        </div>
        <button
          onClick={() => { setOpen(false); openLead("book_inspection", { title: "Claim Your Free Inspection" }); }}
          className="btn-ripple mt-5 w-full bg-royal hover:bg-royal/90 text-white font-semibold py-3 rounded-sm transition-colors"
          data-testid="exit-cta"
        >
          Claim My Free Inspection
        </button>
        <button onClick={() => setOpen(false)} className="mt-2 text-xs text-slate-500 hover:text-slate-300">No thanks, I'll risk the leak</button>
      </DialogContent>
    </Dialog>
  );
}
